import styled from 'styled-components';
import { Flex, Heading } from '@certilogo/design-system-web';

export const Title = styled(Heading).attrs({ type: 'h1', color: 'primaryAccentColor' })``;

export const Header = styled(Flex)`
  flex-direction: column;
  align-items: center;
`;
